import { render } from "./AboutUs.vue?vue&type=template&id=93ab9dc8"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"
script.render = render

export default script